export function getCmpData() {
  if (!window.__cmp) {
    console.error("[cmp] CMP API is not available but is required");
    return null;
  }

  const { vendorsList, vendorConsents, purposeConsents } = window.__cmp("getCMPData");

  return { vendorsList, vendorConsents, purposeConsents };
}
